import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router';

// Translations
import translate from '../Translate.js';

// Helpers
import { confirm, getURLSegment, toggleDrawer } from '../../helpers/helpers.js';

// Components
import FauxSelect from '../Common/FauxSelect';

const UsersList = observer(class UsersList extends React.Component {
  constructor() {
    super();
    this.toggleEnrollments = this.toggleEnrollments.bind(this);
    this.selectOption = this.selectOption.bind(this);
    this.deleteConfiguration = this.deleteConfiguration.bind(this);
  }

  componentWillMount() {
    this.state = {
      showEnrollments: [],
      enrollmentSid: null,
      enrollmentName: null,
      userSid: null,
      configuration: null,
      configurationSid: null,
      fundingRuleSid: null
    };

    if(getURLSegment(this, 2) !== 'view') {
      this.props.store.EnrollmentStore.getUsers();
    }
  }

  toggleEnrollments(userSid) {
    let visibleEnrollments = [...this.state.showEnrollments];
    let thisIndex = visibleEnrollments.indexOf(userSid);

    if(thisIndex > -1) {
      // Enrollments are already showing for this user, so hide them
      visibleEnrollments.splice(thisIndex, 1);

      // Update the state
      this.updateEnrollments(visibleEnrollments)
    } else {
      // Enrollments are not showing yet, so show them
      visibleEnrollments.push(userSid);

      // Get the enrollments and then update the state
      this.props.store.EnrollmentStore.getUserEnrollments(
        userSid,
        () => this.updateEnrollments(visibleEnrollments)
      );
    }
  }

  updateEnrollments(visibleEnrollments) {
    this.setState({
      showEnrollments: visibleEnrollments
    });
  }

  userActions() {
    const { translation } = this.props;

    let actions = [
      {
        title: translation.actions.funding_rules.label,
        action: 'UserFundingRules'
      }
    ]

    return actions;
  }

  enrollmentActions(enrollment) {
    const { translation } = this.props;

    // Enrollment actions
    let actions = [
      {
        title: translation.actions.proctor_approvals.label,
        action: 'LocateProctor'
      },
      {
        title: translation.actions.funding_rules.label,
        action: 'FundingRules'
      },
      {
        title: translation.actions.impersonate.label,
        action: 'Impersonate',
        helper: translation.actions.impersonate.helper
      }
    ]

    let configActions = []

    if(enrollment.examConfiguration.sid) {
      // If the enrollment has an exam configuration
      configActions = [
        {
          title: translation.actions.manage_exam_configuration.label,
          action: 'EditEnrollmentException'
        }, {
          title: translation.actions.delete_exam_configuration.label,
          action: 'DeleteExamConfiguration'
        }
      ]
    } else {
      // If the enrollment does not have an exam configuration
      configActions = [
        {
          title: translation.actions.add_exam_configuration.label,
          action: 'EnrollmentException'
        }
      ]
    }

    actions = actions.concat(configActions);

    if(enrollment.role.toLowerCase() === 'instructor') {
      actions = [
        {
          title: translation.actions.impersonate.label,
          action: 'Impersonate',
          helper: translation.actions.impersonate.helper
        }
      ]
    }

    return actions;
  }

  selectOption(e, props) {
    const action = e.target.getAttribute('data-action');
    const { SettingsStore, StudentStore } = this.props.store;
    let { pathname } = this.props.routing.location;

    this.props.parent.setState({
      enrollmentSid: props.enrollmentSid,
      enrollmentName: props.enrollmentName,
      userSid: props.userSid,
      configurationSid: props.configurationSid,
      configuration: props.configuration
    });

    if(action === 'DeleteExamConfiguration') {
      this.deleteConfiguration(props.userSid, props.enrollmentSid, props.configurationSid);
    } else if(action !== 'UserFundingRules' && action !== 'Impersonate') {
      const drawerContent = action;
      toggleDrawer(e, this.props.parent, drawerContent);
    }

    // Set store enrollment configuration if editing a config
    if(action === 'EditEnrollmentException') {
      this.props.store.EnrollmentStore.enrollmentConfiguration = props.configuration;
    }

    // Add fundingRuleScope and scopeSid if managing funding rules

    // Enrollment funding rules
    if(action === 'FundingRules') {
      console.log(props.userSid);

      // Funding rules can either have an enrollmentSid or userSid
      // not both, so remove the userSid from the state because
      // it gets passed to the funding rule form
      this.props.parent.setState({
        userSid: null
      });

      pathname += `?fundingRuleScope=enrollmentSid&scopeSid=${props.enrollmentSid}`;
      this.props.routing.push(pathname);
    }

    // User funding rules
    if(action === 'UserFundingRules') {
      toggleDrawer(e, this.props.parent, 'FundingRules');

      // Funding rules can either have an enrollmentSid or userSid
      // not both, so remove the userSid from the state because
      // it gets passed to the funding rule form
      this.props.parent.setState({
        enrollmentSid: null
      });

      pathname += `?fundingRuleScope=userSid&scopeSid=${props.userSid}`;
      this.props.routing.push(pathname);
    }

    // Impersonate student
    if(action === 'Impersonate') {
      StudentStore.impersonate(props.enrollmentSid, SettingsStore.integration.accessKey, null, props.userSid);
    }
  }

  deleteConfiguration(userSid, enrollmentSid, configurationSid) {
    const { translation } = this.props;

    const msg = {
      heading: translation.delete_confirm.heading,
      body: translation.delete_confirm.body,
      button: translation.delete_confirm.button
    }

    confirm(
      msg,
      () => this.props.store.EnrollmentStore.deleteEnrollmentConfiguration(
        userSid,
        enrollmentSid,
        configurationSid
      )
    );
  }

  renderEnrollments(userSid) {
    const { translation } = this.props;
    const { EnrollmentStore, SessionStore } = this.props.store;

    // Wait until user enrollments and configurations are done loading to render
    if(
      SessionStore.loadingCalls.indexOf('GetUserEnrollments') < 0 && SessionStore.loadingCalls.indexOf('GetEnrollmentConfigurations') < 0
    ) {
      return (
        <tr className={`
          row-collapsed
          ${this.state.showEnrollments.indexOf(userSid) > -1 ? 'expanded' : ''}
        `}>
          <td colSpan="4">
            <table id={`enrollments-${userSid}`}>
              <thead>
                <tr>
                  <th id={`heading-${userSid}-course`} scope="col">
                    {translation.course}
                  </th>
                  <th id={`heading-${userSid}-role`} scope="col" tabIndex="0">
                    {translation.role}
                  </th>
                  <th id={`heading-${userSid}-actions`} scope="col">
                    {translation.action}
                  </th>
                </tr>
              </thead>
              <tbody>
                {
                  EnrollmentStore.userEnrollments[userSid] &&
                  EnrollmentStore.userEnrollments[userSid].map(
                  (enrollment, j) =>
                  <tr key={j}>
                    <td aria-labelledby={`heading-${userSid}-course`}>
                      {enrollment.course.title} ({enrollment.course.code})
                    </td>
                    <td aria-labelledby={`heading-${userSid}-role`}>
                      {enrollment.role}
                    </td>
                    <td aria-labelledby={`heading-${userSid}-actions`} className="actions">
                      {
                        (
                          enrollment.role.toLowerCase() === 'learner' ||
                          enrollment.role.toLowerCase() === 'instructor'
                        ) &&
                        <FauxSelect
                          default={translation.action_select}
                          options={this.enrollmentActions(enrollment)}
                          onClick={this.selectOption}
                          userSid={enrollment.user.sid}
                          enrollmentSid={enrollment.enrollmentSid}
                          enrollmentName={`${enrollment.user.firstName} ${enrollment.user.lastName}`}
                          configuration={enrollment.examConfiguration}
                          configurationSid={enrollment.examConfiguration.sid}
                          parent={this}
                          skipText={true}
                        />
                      }
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </td>
        </tr>
      )
    }

    return null;
  }

  render() {
    const { EnrollmentStore, SessionStore } = this.props.store;
    const { translation } = this.props;

    if(EnrollmentStore.installUsers.length > 0) {
      return(
        <table>
          <thead>
            <tr>
              <th id="heading-name" className="subtitle" scope="col">{translation.student}</th>
              <th id="heading-email" className="subtitle" scope="col">{translation.email}</th>
              <th id="heading-action" className="subtitle" scope="col">{translation.action}</th>
            </tr>
          </thead>
          <tbody>
            {EnrollmentStore.installUsers.map(
              (key, i) =>
              {
                return ([
                  <tr key={i}>
                    <td aria-labelledby="heading-name">
                      <div className="cell-wrap">
                        <Link
                          to={`/users/view/${key.sid}`}
                          title={`${key.lastName}, ${key.firstName}, ${translation.view_details}`}
                        >
                          {key.lastName}, {key.firstName}
                        </Link>

                        <button
                          className={`btn--expand ${this.state.showEnrollments.indexOf(key.sid) > -1 ? 'expanded' : ''}`}
                          title={translation.enrollments}
                          onClick={() => this.toggleEnrollments(key.sid)}
                        >
                          <span className="meta">{translation.enrollments}</span>
                        </button>
                      </div>
                    </td>
                    <td aria-labelledby="heading-email">
                      <a className="title-link" href={`mailto:${key.email}`}>{key.email}</a>
                    </td>
                    <td aria-labelledby="heading-action" className="actions">
                      <FauxSelect
                        default={translation.action_select}
                        options={this.userActions()}
                        onClick={this.selectOption}
                        userSid={key.sid}
                        parent={this}
                        skipText={true}
                      />
                    </td>
                  </tr>,
                  this.renderEnrollments(key.sid)
                ])
              }
            )}
          </tbody>
        </table>
      )
    } else if(!SessionStore.loading && EnrollmentStore.installUsers.length === 0) {
      return (
        <span className="no-results">{translation.no_results}</span>
      )
    }

    return null;
  }
})

export default translate('UsersList')(UsersList);



// WEBPACK FOOTER //
// ./src/app/components/Roster/UsersList.js